// @flow strict

import * as React from 'react';
import { Select, Option } from '../../../../internal/Select';
// eslint-disable-next-line css-modules/no-unused-class
import styles from '../../styles.scss';
import Search from '../../../../internal/Search';
import type { OptionType } from '../types';

export type PropsType = {|
  action: string,
  fieldName: string,
  searchTerm: string,
  location: string,
  service: string,
  industry: string,
  locations: Array<OptionType>,
  services: Array<OptionType>,
  industries: Array<OptionType>,
|};

export default (props: PropsType) => {
  const [location, setLocation] = React.useState(props.location);
  const [service, setService] = React.useState(props.service);
  const [industry, setIndustry] = React.useState(props.industry);
  const formElement = React.useRef<HTMLFormElement | null>(null);
  const onSubmit = () => {
    if (formElement.current) {
      formElement.current.submit();
    }
  };

  return (
    <div className={styles.filter}>
      <Search
        ref={formElement}
        className={styles.searchBar}
        action={props.action}
        placeholder="Search partners"
        fieldName={props.fieldName}
        formId="partners"
        searchTerm={props.searchTerm}
        background="Dark"
      />
      <div className={styles.optionGroup}>
        <Select
          className={styles.option}
          background="Dark"
          name="location"
          form="partners"
          onChangeValue={val => {
            setLocation(val);
            onSubmit();
          }}
          value={location}
        >
          {props.locations.map(({ value, text }, key) => (
            // eslint-disable-next-line react/no-array-index-key
            <Option value={value} text={text} key={key} />
          ))}
        </Select>
        <Select
          className={styles.option}
          background="Dark"
          name="service"
          form="partners"
          onChangeValue={val => {
            setService(val);
            onSubmit();
          }}
          value={service}
        >
          {props.services.map(({ value, text }, key) => (
            // eslint-disable-next-line react/no-array-index-key
            <Option value={value} text={text} key={key} />
          ))}
        </Select>
        <Select
          className={styles.option}
          background="Dark"
          name="industry"
          form="partners"
          onChangeValue={val => {
            setIndustry(val);
            onSubmit();
          }}
          value={industry}
        >
          {props.industries.map(({ value, text }, key) => (
            // eslint-disable-next-line react/no-array-index-key
            <Option value={value} text={text} key={key} />
          ))}
        </Select>
      </div>
    </div>
  );
};
